<template>
	<div class="counterpart_table_header">
		<div class="search_container">
			<div class="">
				<p class="absolute-box ">
					<span class="absolute-pos icon-left">
						<SearchIcon />
					</span>

					<input class="absolute-pos input-center" type="text"
						placeholder="Buscar por número de documento" :value="searchValue"
						@input="$emit('update:searchValue', $event.target.value)" />
					<span v-if="searchValue" class="absolute-pos icon-right clear_button"
						@click="$emit('update:searchValue', '')">
						<Ecs class="icon is-small is-right ecs" />
					</span>
				</p>
			</div>
		</div>
		<div class="filter_container">
			<SimpleButton @click="$emit('select-filter', 'all')"
				class="select_button first_button nobreak"
				v-bind:class="{ black_button: activeFilter === 'all' }">
				Ver Todos
			</SimpleButton>
			<SimpleButton @click="$emit('select-filter', 'Sin Clasificar')"
				class="select_button nobreak" v-bind:class="{
					black_button: activeFilter === 'Sin Clasificar',
				}">
				🔍 Sin Clasificar
			</SimpleButton>
			<SimpleButton @click="$emit('select-filter', 'Contraparte')"
				class="select_button nobreak" v-bind:class="{ black_button: activeFilter === 'Contraparte' }">
				Por Contraparte
			</SimpleButton>
			<SimpleButton @click="$emit('select-filter', 'Documento')"
				class="select_button last_button nobreak"
				v-bind:class="{ black_button: activeFilter === 'Documento' }">
				Por Documento
			</SimpleButton>
		</div>
	</div>
</template>

<script>
import SimpleButton from "@/components/modals/SimpleButton.vue";
import Ecs from "@/components/svg/Ecs.vue";
import SearchIcon from "@/components/svg/SearchIcon.vue";

export default {
	name: "DocsFilterToolbar",
	components: { SimpleButton, Ecs, SearchIcon },
	props: {
		searchValue: { type: String, default: "" },
		activeFilter: { type: String, default: "all" },
	},
};
</script>

<style scoped lang="scss">
.counterpart_table_header {
	background-color: var(--Gray-200, #eaecf0);
	height: 60px;
	width: 100%;
	padding: 12px 20px;
	display: flex;
	flex-direction: row;
}

.absolute-box {
	position: relative;
	min-width: 200px;
	min-width: 300px;

	.absolute-pos {
		position: absolute;
		top: 0;
		left: 0;
		padding: 8px;
		z-index: 5;
	}

	.icon-left {
		height: 20px;
	}

	.input-center {
		margin-left: 28px;
		z-index: 2;
		border-width: 0;
		width: 80%;
		background-color: transparent;
	}

	.input-center:focus {
		outline: none;
		border-color: transparent;
		box-shadow: none;
	}

	.icon-right {
		height: 20px;
		right: 0px;
		left: auto;
	}
}

.search_container {
	border-radius: 8px;
	border: 1px solid var(--Gray-300, #D0D5DD);
	background: var(--Base-White, #FFF);
	box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
}

.filter_container {
	display: flex;
	flex-direction: row;
	justify-content: flex-end;
	gap: 0;
	flex: 2;
}

.ecs {
	width: 100%;
	position: relative;
	height: 20px;
	overflow: hidden;
	flex-shrink: 0;
}

.clear_button {
	background: transparent;
	border: none;
	font-size: 16px;
	cursor: pointer;
	color: #888;
	z-index: 2;
}

.nobreak {
	white-space: preserve nowrap;
}

$select_transition: 0.1s;

.select_button {
	text-align: center;
	border-radius: 0;
	border-top: 1px solid #ccc;
	border-bottom: 1px solid #ccc;
	border-right: 0.5px solid #ccc;
	border-left: 0.5px solid #ccc;
	margin: 0;
	padding: clamp(5px, 6px, 8px) clamp(10px, 12px, 16px);
	background-color: var(--Base-White, #ffffff);
	color: #000000;
	transition: all $select_transition ease;
}

.select_button:first-of-type {
	border-left: 1px solid #ccc;
}

.select_button:last-of-type {
	border-right: 1px solid #ccc;
}

.select_button:hover {
	background-color: #c7c7c7;
	color: #000000;
	transition: all $select_transition ease;
}

.first_button {
	border-top-left-radius: 8px;
	border-bottom-left-radius: 8px;
}

.last_button {
	border-top-right-radius: 8px;
	border-bottom-right-radius: 8px;
}

.black_button {
	background-color: #002e33 !important;
	color: var(--Base-White, #ffffff) !important;
	transition: all $select_transition ease;
}

.black_button:hover {
	background-color: #185555 !important;
	color: var(--Base-White, #ffffff) !important;
	transition: all $select_transition ease;
}
</style>
